import React from 'react';
import { sanitiseHTML, stringToObject } from '../../../../../legacy/utils/helpers';
import { TherapyAddressImage } from './TherapyAddressImage';
import { Typography } from "src/latest/src/components";

interface PracticeAddressProps {
  choices: any[];
  isPracticeAddress: boolean;
}

export const PracticeAddress: React.FC<PracticeAddressProps> = ({
  choices,
  isPracticeAddress,
}) => {
  return (
    <>
      {choices?.map((choice, index) => {
        const metaData: any = stringToObject(choice.metadata);

        if (choice?.selected || isPracticeAddress) {
          return (
            <div
              key={index}
              className={
                'practice-profile__in-person-ofc  therapist-profile__in-person-ofc'
              }
            >
              <TherapyAddressImage
                id={metaData?.img}
                isAppointmentLocation={false}
              />

              <div className='practice-profile__in-person-ofc-address  therapist-profile__in-person-ofc-address'>
                <Typography
                  variant='size-16'
                  weight='bold'
                  color='color-2'
                  className='d-inline-block'
                >
                  {choice?.description}
                </Typography>
                {metaData?.addressInfo1 && (
                  <p>{sanitiseHTML(metaData?.addressInfo1)}</p>
                )}
                {metaData?.addressInfo2 && (
                  <p>{sanitiseHTML(metaData?.addressInfo2)}</p>
                )}
                {metaData?.addressInfo3 && (
                  <p>{sanitiseHTML(metaData?.addressInfo3)}</p>
                )}
                {metaData?.addressInfo4 && (
                  <p>{sanitiseHTML(metaData?.addressInfo4)}</p>
                )}
              </div>
            </div>
          );
        } else {
          return null;
        }
      })}
    </>
  );
};
